import { ContentContext, CountryContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import GlobalLink from 'Components/common/GlobalLink';
import RegionLink from 'Components/common/RegionLink';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const atlas = new AtlasMetadataClient();

const RegionNav = () => {
  const country = useContext(CountryContext);
  if (!country) return null;
  return (
    <span className='region-link'>
      <RegionLink region={atlas.getCountry(country).region.slug} />
    </span>
  );
};

const PlaceReferral = (props) => {
  const content = useContext(ContentContext);

  const { width } = useWindowDimensions();

  const showRegion = width > 768;

  return (
    <div className={classnames(component)}>
      <nav className='referrals'>
        {showRegion ? (
          <>
            <span className='title'>
              {content.common.nav.title}
            </span>
            <span className='global-link'>
              <GlobalLink />
            </span>
            <RegionNav />
          </>
        ) : (
          <>
            <span className='title'>
              <GlobalLink>{content.common.nav.title}</GlobalLink>
            </span>
          </>
        )}
      </nav>
    </div>
  );
};

export default PlaceReferral;
